<template>
  <div class="send-reveivepackge">
    <!--    <p class="desc">Return information</p>-->
    <i-spin v-if="loading" fix>
      <i-icon type="ios-loading" size="40" class="spin-icon-load" />
    </i-spin>
    <div v-show="!loading">
      <div class="form">
        <p class="form-title">Return to</p>
        <InputWrap class="row shipper" size="large">
          <i-input v-model="firstname" class="shipper-name" size="large" placeholder="First Name" />
          <i-input v-model="lastname" class="shipper-name" size="large" placeholder="Last Name" />
        </InputWrap>
        <InputWrap class="row shipping-address" size="large">
          <i-input ref="shipaddress" v-model="sendAddr1" class="street" size="large" placeholder="Street address" />
          <i-input
            v-model="sendAddr2"
            class="floor"
            size="large"
            placeholder="Apt / Unit / Floor / Suite etc.(optional)"
          />
        </InputWrap>
        <InputWrap class="row" size="large">
          <div class="sp-wrap">
            <i-input v-model="sendCountry" class="country" disabled size="large" />
            <i-select
              v-model="state"
              class="state"
              not-found-text=""
              filterable
              remote
              :loading="stateLoading"
              size="large"
            >
              <i-option v-for="iState in states" :key="iState.key" :value="iState.key">{{ iState.value }}</i-option>
            </i-select>
            <i-input v-model="sendCity" class="city" size="large" placeholder="City" />
          </div>
        </InputWrap>
        <InputWrap class="row" size="large">
          <div class="sp-wrap">
            <i-input v-model="zipcode" class="zip-code" size="large" placeholder="Zipcode" />
            <i-input v-model="sendMobile" class="phone-number" size="large" placeholder="Phone" />
          </div>
        </InputWrap>
      </div>
      <div class="boxes">
        <div class="packge">
          <p class="boxes-title">
            Shipping insurance
          </p>
          <p class="boxes-desc">
            By creating shipment, you agree to our
            <a href="https://support.movingkite.com/hc/en-us/articles/5926592731419-Terms-of-Insurance" target="_blank">
              Terms of Shipping Insurance
            </a>
          </p>
          <ul class="box-list">
            <li v-for="(box, index) in boxNum" :key="box">
              <InputWrap size="large" class="box-item" :label="box | boxNumber">
                <i-select
                  :value="boxes[index].insurance"
                  not-found-text=""
                  remote
                  size="large"
                  @on-select="selectInsurance($event, index)"
                >
                  <i-option
                    v-for="insurance in insurances"
                    :key="insurance.insurance"
                    :value="insurance.insurance"
                    :desc="insurance.desc"
                    >{{ insurance.desc }}</i-option
                  >
                </i-select>
              </InputWrap>
            </li>
          </ul>
          <p class="title">Signature options</p>
          <ul class="type-list">
            <li class="type-item" :class="{ active: signType == 'NO' }" @click="changeReturnType('NO')">
              <div class="type-left">
                <p class="type-title">
                  No signature Required
                  <i-poptip transfer class="tip" width="320" trigger="hover" placement="right">
                    <i-icon type="ios-help-circle" color="#ccc" />
                    <div slot="content" class="font-light" style="white-space: pre-line;">
                      There are many shipments FedEx delivers that do not require a signature from the recipient. In
                      many cases, FedEx will still attempt to obtain a signature at the designated delivery address. If
                      no one is available to sign, FedEx may leave the package in a safe place without obtaining a
                      signature.
                    </div>
                  </i-poptip>
                </p>
              </div>
              <div class="type-right">
                <label>Free</label>
              </div>
            </li>
            <li class="type-item" :class="{ active: signType == 'DIRECT' }" @click="changeReturnType('DIRECT')">
              <div class="type-left">
                <p class="type-title">
                  Direct Signature
                  <i-poptip transfer class="tip" width="320" trigger="hover" placement="right">
                    <i-icon type="ios-help-circle" color="#ccc" />
                    <div slot="content" class="font-light" style="white-space: pre-line;">
                      FedEx obtains a signature from someone at the delivery address who is at least the age of majority
                      (no longer a minor) in the destination country. Government-issued photo identification or other
                      identification customarily accepted by local authorities is required. If there is no eligible
                      recipient at the address, FedEx may reattempt the delivery. For U.S. deliveries, the recipient
                      must be 21 years of age and present government-issued photo identification.
                    </div>
                  </i-poptip>
                </p>
              </div>
              <div class="type-right">
                <label>${{ DIRECT_PRICE }}</label>
                <span> / box</span>
              </div>
            </li>
            <li class="type-item" :class="{ active: signType == 'ADULT' }" @click="changeReturnType('ADULT')">
              <div class="type-left">
                <p class="type-title">
                  Adult signature Required
                  <i-poptip transfer class="tip" width="320" trigger="hover" placement="right">
                    <i-icon type="ios-help-circle" color="#ccc" />
                    <div slot="content" class="font-light" style="white-space: pre-line;">
                      Someone at the recipient’s address must sign for the delivery. Direct signature deliveries are
                      made to the address on the mailing label, not to an individual recipient. If no one is at the
                      address, FedEx may reattempt the delivery.
                    </div>
                  </i-poptip>
                </p>
              </div>
              <div class="type-right">
                <label>${{ ADULT_PRICE }}</label>
                <span> / box</span>
              </div>
            </li>
          </ul>
          <div class="type-pickup">
            <p class="type-pickup-title">Estimate received date</p>
            <div v-if="returnDateLoading" class="loading-wrap">
              <i-spin>
                <i-icon type="ios-loading" size="40" class="spin-icon-load" />
              </i-spin>
            </div>
            <p v-else-if="!zipcodeChecked || !addressChecked" class="type-pickup-error">
              Please complete your receiving information first
            </p>
            <p v-else-if="returnStartDateError" class="type-pickup-error">
              {{ returnStartDateError }}
            </p>
            <template>
              <InputWrap class="earliest-time" size="large">
                <i-date-picker
                  v-model="returnDate"
                  :disabled="!!returnStartDateError || !zipcodeChecked || returnDateLoading"
                  :options="pickOptions"
                  transfer
                  class="date"
                  size="large"
                  format="MM/dd/yy"
                  placeholder="mm/dd/yy"
                  @on-change="onDeliveryDateChange"
                />
              </InputWrap>
              <p v-show="returnDate" class="type-pickup-desc">
                According to your return information, Movingkite will ship your package on
                <span>{{ sendDate }}</span
                >, you can change any information before the date. If you change information after we ship, it will be
                extra charge
              </p>
            </template>
          </div>
        </div>
        <div class="info-footer">
          <Button :loading="saveLoding" class="btn" @click="saveOrder">Confirm</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Input from '../../../components/input/Input';
import InputWrap from '../../../components/input/InputWrap';
import Button from '../../../components/button/Button';
import moment from 'moment';
import { mapState, mapActions } from 'vuex';
import { API } from '../../../net/http';
import jsLoader from '../../../utils/jsLoader';

export default {
  components: {
    Input,
    InputWrap,
    Button,
  },
  props: ['trkNum', 'backId', 'boxNum'],
  data() {
    return {
      boxes: [],
      states: [],
      returnPriceLoading: true,
      // warehouseName: '',
      // warehouseCode: '',
      zipcode: '',
      returnPrice: '--',
      state: '',
      stateLoading: true,
      sendCity: '',
      firstname: '',
      lastname: '',
      sendAddr1: '',
      sendAddr2: '',
      sendMobile: '',
      saveLoding: false,
      sendCountry: 'US',
      rangeLoading: true,
      pickupDate: [],
      pickOptions: {
        disabledDate: val => {
          let pk = moment(val),
            vk = moment(this.returnStartDate, 'MM/DD/YYYY');
          let flag = pk.isBefore(vk);
          if (this.notHomeDelivery) {
            flag = flag || pk.isoWeekday() > 5;
          }
          flag = flag || this.isHolidays(pk);
          return flag;
        },
      },
      signType: '',
      ADULT_PRICE: '-.--',
      DIRECT_PRICE: '-.--',
      holidayDate: [],
      notHomeDelivery: true,
      returnDateLoading: false,
      returnStartDate: '',
      returnStartDateError: '',
      returnDate: '',
      sendDate: '',
      loading: true,
      zipcodeChecked: false,
      addressChecked: false,
      transDay: 0,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.initStates();
      this.initPrice();
      this.initInsurance();
      this.initBoxes();
      if (this.backId != '0') {
        this.initReturnInfo();
      } else {
        this.loading = false;
      }
      this.$nextTick(() => {
        jsLoader(
          'https://maps.googleapis.com/maps/api/js?key=AIzaSyBZhHEG1ZINGM7scAC6fBpHP3CgVyh-jd0&libraries=places&v=weekly',
          'google',
        ).then(() => {
          this.$maps = window.google.maps;
          this.initAutoComplete();
        });
      });
    },
    initReturnInfo() {
      this.loading = true;
      this.$post(API.orderBackInfo, { backId: this.backId })
        .then(res => {
          this.loading = false;
          if (res.success) {
            let {
              housePostcode,
              houseState,
              sendAddr1,
              sendAddr2,
              sendCity,
              sendCountry,
              sendFirstName,
              sendLastName,
              sendMobile,
              sendPostcode,
              sendState,
              recvLdt,
              insurances,
            } = res.data;

            this.housePostcode = housePostcode;
            this.houseState = houseState;
            // this.returnDate = leaveLdt;
            this.sendAddr1 = sendAddr1;
            this.sendAddr2 = sendAddr2;
            this.sendCity = sendCity;
            this.sendCountry = sendCountry;
            this.firstname = sendFirstName;
            this.lastname = sendLastName;
            this.sendMobile = sendMobile;
            this.zipcode = sendPostcode;
            this.state = sendState;
            this.returnDate = moment(recvLdt, 'MM/DD/YYYY').toDate();
            this.boxes = insurances.map(item => {
              item.insurance = Number(item.insurance).toString();
              return item;
            });
          }
        })
        .catch(() => {
          this.loading = true;
        });
    },
    initStates() {
      this.stateLoading = true;
      this.getStates()
        .then(res => {
          this.stateLoading = false;
          if (res.success) {
            this.states = res.data;
          }
        })
        .catch(() => {
          this.stateLoading = false;
        });
    },
    initPrice() {
      this.initReturnPrice();
    },
    initInsurance() {
      this.insuranceLoading = true;
      this.getInsurance()
        .then(() => {
          this.insuranceLoading = false;
          // this.initInsuranceBox();
        })
        .catch(() => {
          setTimeout(() => {
            this.initInsurance();
          }, 1500);
        });
    },
    initBoxes() {
      this.boxes = [];
      for (let i = 0; i < this.boxNum.length; i++) {
        this.boxes.push({
          insurance: '0',
          desc: 'Not insured',
        });
      }
    },
    initReturnPrice() {
      this.returnPriceLoading = true;
      this.getReturnPrice()
        .then(res => {
          this.returnPriceLoading = false;
          if (res.success) {
            let { ADULT, DIRECT } = res.data;
            this.ADULT_PRICE = ADULT;
            this.DIRECT_PRICE = DIRECT;
          } else {
            setTimeout(() => {
              this.initReturnPrice();
            }, 1500);
          }
        })
        .catch(() => {
          setTimeout(() => {
            this.initReturnPrice();
          }, 1500);
        });
    },
    initReturnDate() {
      if (
        this.sendAddr1.trim() === '' ||
        this.state.trim() === '' ||
        this.sendCity.trim() === '' ||
        this.zipcode.trim() === '' ||
        !this.zipcodeChecked
      ) {
        this.addressChecked = false;
        return;
      }
      this.addressChecked = true;
      this.returnDateLoading = true;
      this.returnStartDateError = '';
      this.getReturnDate({
        orderNum: this.sendInfo.orderNum,
        houseId: this.sendInfo.houseId,
        address: {
          postCode: this.zipcode,
          state: this.state,
          city: this.sendCity,
          address1: this.sendAddr1,
          address2: this.sendAddr2,
        },
      })
        .then(res => {
          if (!res.success) {
            this.returnStartDateError = res.message;
            this.$Message.error(res.message);
            return;
          }
          const data = res.data;
          this.transDay = data.transDay;
          this.returnStartDate = data.deliveryStartDate;

          this.notHomeDelivery = data.serviceType !== 'GROUND_HOME_DELIVERY';
          this.holidayDate = [];
          for (const date of data.holidayDate) {
            this.holidayDate.push(moment(date, 'MM/DD/YYYY'));
          }
          if (this.returnDate) {
            let startDateMoment = moment(data.recvStartDate, 'MM/DD/YYYY');
            if (moment(this.returnDate).isBefore(startDateMoment)) {
              this.returnDate = '';
            }
          }
        })
        .catch(() => {
          this.returnStartDateError = 'system error.';
        })
        .finally(() => {
          this.returnDateLoading = false;
        });
    },
    isHolidays(localDate) {
      let date = moment(localDate);
      for (let holiday of this.holidayDate) {
        if (date.isSame(holiday)) return true;
      }
      return false;
    },
    onDeliveryDateChange() {
      this.getSendDate({
        orderNum: this.sendInfo.orderNum,
        deliveryDate: this.returnDate,
        houseId: this.sendInfo.houseId,
        transDay: this.transDay,
      }).then(res => {
        if (!res.success) {
          this.$Message.error(res.message);
          return;
        }
        this.sendDate = res.data.sendDateStr;
      });
    },
    changeReturnType(signType) {
      this.signType = signType;
      if (!this.returnStartDate) {
        this.initReturnDate();
      }
    },
    initAutoComplete() {
      let address1Field = this.$refs.shipaddress.$el.children[1];
      let autocomplete = new this.$maps.places.Autocomplete(address1Field, {
        types: ['address'],
        componentRestrictions: {
          country: ['us'],
        },
        fields: ['address_components', 'geometry'],
      });
      autocomplete.addListener('place_changed', () => {
        let place = autocomplete.getPlace();
        this.formarPlace2data(place);
      });
    },
    formarPlace2data(place) {
      let address1 = '',
        postcode = '',
        locality = '',
        state = '';
      for (const component of place.address_components) {
        const componentType = component.types[0];
        switch (componentType) {
          case 'street_number': {
            address1 = `${component.long_name} ${address1}`;
            break;
          }
          case 'route': {
            address1 += component.short_name;
            break;
          }
          case 'postal_code': {
            postcode = `${component.long_name}${postcode}`;
            break;
          }
          case 'postal_code_suffix': {
            postcode = `${postcode}-${component.long_name}`;
            break;
          }
          case 'locality': {
            locality = component.long_name;
            break;
          }
          case 'administrative_area_level_1': {
            state = component.short_name;
            break;
          }
        }
      }
      this.state = state;
      this.sendCity = locality;
      // this.sendCountry = country;
      if (postcode) {
        this.zipcode = postcode;
      } else {
        this.zipcode = '';
      }
      this.sendAddr1 = `${address1}`;
    },
    selectInsurance(row, index) {
      this.boxes[index].insurance = row.value;
      this.boxes[index].desc = row.label;
    },
    saveOrder() {
      if (this.saveLoding) {
        return;
      }
      if (this.firstname.trim() === '' || this.lastname.trim() === '') {
        this.toast('Receiver name is required.');
        return;
      }
      if (this.sendAddr1.trim() === '') {
        this.toast('Shipping address is required.');
        return;
      }
      if (this.state.trim() === '') {
        this.toast('Province is required.');
        return;
      }
      if (this.sendCity.trim() === '') {
        this.toast('City is required.');
        return;
      }
      if (this.zipcode.trim() === '') {
        this.toast('Zip code required.');
        return;
      }
      if (!this.zipcodeChecked) {
        this.toast('Zip code is invalid.');
        return;
      }
      if (this.sendMobile.trim() === '') {
        this.toast('Phone number.');
        return;
      }
      if (!this.returnDate) {
        this.toast('please select receive date.');
        return;
      }
      if (!this.signType) {
        this.toast('Please select Signature options.');
        return;
      }
      let body = {
        sendAddr1: this.sendAddr1,
        sendCity: this.sendCity,
        sendFirstName: this.firstname,
        sendLastName: this.lastname,
        sendPostcode: this.zipcode,
        sendState: this.state,
        sendMobile: this.sendMobile,
        orderNum: this.sendInfo.orderNum,
        houseId: this.sendInfo.houseId,
        sendCountry: this.sendCountry,
        sendAddr2: this.sendAddr2,
        trkNum: this.trkNum,
        signType: this.signType,
        recvLdt: moment(this.returnDate).format('MM/DD/YYYY'),
        backId: this.backId,
        insurances: this.boxes,
        transDays: this.transDay,
      };
      //TODO 检查数据
      this.saveLoding = true;
      this.$emit('change-loading', true);
      (this.backId == '0' ? this.orderBackSave(body) : this.orderBackUpdate(body))
        .then(res => {
          this.saveLoding = false;
          this.$emit('change-loading', false);
          if (res.success) {
            this.$emit('change-back-id', res.data.backId);
            this.$Message.success('success');
            this.$emit('change-route', 'receive-pay');
          } else {
            this.$Message.error({
              content: res.message,
              duration: 5,
            });
          }
        })
        .catch(() => {
          this.saveLoding = false;
          this.$emit('change-loading', false);
        });
    },
    toast(msg) {
      this.$Message.warning({
        content: msg,
        duration: 3,
      });
    },
    ...mapActions('send', [
      'orderBackSave',
      'getStates',
      'getReturnPrice',
      'getReturnDate',
      'getSendDate',
      'orderBackUpdate',
      'getInsurance',
    ]),
  },
  filters: {
    numer(index) {
      return `#${index + 1}`;
    },
    boxNumber(boxNum) {
      return `#${boxNum}`;
    },
  },
  computed: {
    ...mapState('send', ['sendInfo', 'insurances']),
  },
  watch: {
    zipcode(nval) {
      this.zipcodeChecked = false;
      this.returnDateLoading = true;
      this.returnStartDate = '';
      let zipreg = /^\d{5}(?:[-\s]\d{4})?$/;
      if (zipreg.test(this.zipcode)) {
        this.zipcodeChecked = true;
        this.initReturnDate(nval);
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../../assets/css/main.less';
@import '../../../assets/fonts/font.less';
.form-title {
  .font-regular;
  font-size: 14px;
  font-weight: 400;
  color: #262626;
}
.send-reveivepackge {
  position: relative;
  .title {
    .font-regular;
    font-size: 20px;
    font-weight: 400;
    color: @app-black-color;
  }
  .desc {
    .font-regular;
    font-size: 16px;
    font-weight: 400;
    color: @app-black-color;
    line-height: 20px;
    margin-top: 30px;
  }
  .form {
    .row {
      padding-top: 10px;
    }
    .shipper-name {
      width: 246px;
      &:last-child {
        margin-left: 16px;
      }
    }
    .shipping-address {
      .floor {
        margin-top: 16px;
      }
    }
    .sp-wrap {
      display: flex;
      flex-direction: row;
      //justify-content: space-between;
      gap: 16px;
      .country {
        width: 50px;
      }
      .state {
        width: 180px;
      }
      .city {
        width: 246px;
      }
      .zip-code {
        width: 246px;
      }
      .phone-number {
        width: 246px;
      }
    }
  }
  .boxes {
    .boxes-title {
      .font-regular;
      font-size: 14px;
      font-weight: 400;
      color: @app-black-color;
      a {
        padding-left: 16px;
      }
    }
    .boxes-desc {
      .font-light;
      padding-top: 10px;
      font-size: 12px;
      font-weight: 300;
      color: @app-black-color;
      a {
        color: @app-blue-color;
        cursor: pointer;
      }
    }
    .box-list {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      flex-wrap: wrap;
      padding-top: 10px;
      .box-item {
        width: 240px;
        margin-top: 6px;
        .remove {
          .font-light;
          cursor: pointer;
          font-size: 12px;
          color: @app-blue-color;
        }
      }
    }
  }
  .add-boxes {
    .font-light;
    font-size: 14px;
    width: 240px;
    color: @app-blue-color;
    margin-top: 16px;
  }
  .packge {
    padding-top: 36px;
    .title {
      margin-top: 50px;
      .font-regular;
      font-size: 14px;
      font-weight: 400;
      color: @app-black-color;
    }
    .type-list {
      padding-top: 20px;
      overflow: hidden;
      width: 560px;
      .type-item {
        .font-regular;
        width: 508px;
        padding: 15px;
        height: 50px;
        background: #ffffff;
        box-shadow: 0 2px 8px 0 rgba(207, 207, 207, 0.2);
        border-radius: 4px;
        font-size: 14px;
        font-weight: 400;
        float: left;
        color: @app-black-color;
        line-height: 18px;
        border: 1px solid @app-placeholder-color;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        &.active {
          border: 1px solid @app-color;
          .type-footer {
            .type-btn {
              background: @app-color;
              color: #fff;
            }
          }
        }
        .type-left {
          display: flex;
          align-items: center;
          .type-title {
            .font-light;
            font-size: 14px;
            font-weight: 300;
            color: @app-black-color;
            .tip {
              font-size: 16px;
            }
          }
          .type-desc {
            .font-light;
            font-size: 12px;
            font-weight: 300;
            margin-top: 5px;
            text-align: center;
          }
        }
        .type-right {
          display: flex;
          align-items: center;
        }
      }
      .type-item + .type-item {
        margin-top: 16px;
      }
    }
    .type-pickup {
      padding-top: 36px;
      position: relative;
      .type-pickup-title {
        .font-regular;
        font-size: 14px;
        font-weight: 400;
        color: @app-black-color;
      }
      .loading-wrap {
        width: 20px;
        height: 50px;
      }
      .type-pickup-error {
        .font-light;
        font-size: 14px;
        width: 400px;
        font-weight: 300;
        padding-top: 10px;
        color: #ff7070;
      }
      .type-pickup-desc {
        .font-light;
        width: 506px;
        margin-top: 20px;
        background: rgba(255, 170, 133, 0.1);
        border-radius: 4px;
        padding: 16px 36px;
        font-size: 12px;
        font-weight: 300;
        color: @app-body-color;
        span {
          .font-regular;
          font-weight: 500;
        }
      }
      .earliest-time {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding-top: 26px;
        .input {
          width: 100%;
        }
      }
    }
  }
  .info-footer {
    margin-top: 46px;
    .btn {
      width: 146px;
      float: right;
    }
  }
}
/deep/ .ivu-input[disabled],
fieldset[disabled] .ivu-input {
  background-color: #ffffff;
  color: @app-black-color;
  text-align: center;
}
</style>
